// src/components/loading/Loading.js
import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading-overlay" aria-live="polite" aria-busy="true">
      <div className="spinner" role="status" aria-label="Loading..."></div>
    </div>
  );
};

export default Loading;
